module.exports = __webpack_public_path__ + "static/media/11-3.a73a61b3.mp3";